<template>
    <ContentOrLoading>
        <div v-if="lfp_events" class="row">
            <div class="col-12 col-lg-12">
                <div class="form-group">
                    <label for="lfp_id">LFP ID</label>
                    <ValidationProvider name="lfp_id" id="lfp_id" :rules="!evento.experiencia ? 'required' : ''" v-slot="{ errors }">
                        <multiselect
                            v-model="selected"
                            placeholder="Evento LFP"
                            label="nombre"
                            track-by="id"
                            :options="lfp_events"
                            :multiple="false"
                            v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
                        ></multiselect>
                        <span v-if="errors[0]" class="error invalid-feedback d-block">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
import ContentOrLoading from "../components/ContentOrLoading";
export default {
    props: ['evento'],
    data() {
        return {
            lfp_events: null,
            selected: null
        }
    },
    mounted() {
        this.$store.dispatch(this.config.getVuexAlias('back.events.lfp.index')).then(res => {
            this.lfp_events = res.data;

            if(this.evento.lfp_id) {
                this.selected = this.lfp_events.find(el => el.id === this.evento.lfp_id);
            }
        });
    },
    components: {
        ContentOrLoading
    }
}
</script>
